<header class="app-header">
  <div class="brand">
    <img class="brand-logo" src="assets/weekly-plan/school-logo.png" alt="School logo" />
    <span>{{ 'APP.TITLE' | translate }}</span>
  </div>

  <button
    class="user-card-trigger"
    [class.open]="userMenuTrigger.menuOpen"
    [matMenuTriggerFor]="userMenu"
    #userMenuTrigger="matMenuTrigger"
    type="button"
    [attr.aria-label]="'HEADER.USER_MENU' | translate"
  >
    <span class="user-card-avatar-wrap">
      <span class="user-card-avatar" aria-hidden="true">{{ userInitials }}</span>
      <span class="user-card-status" aria-hidden="true"></span>
    </span>
    <span class="user-card-meta">
      <span class="user-card-name">{{ userName }}</span>
      <span class="user-card-role" *ngIf="userRole">{{ userRoleLabel }}</span>
    </span>
    <mat-icon class="user-card-chevron">expand_more</mat-icon>
  </button>

  <mat-menu #userMenu="matMenu" xPosition="before" class="app-user-menu">
    <div class="user-menu-hero" (click)="$event.stopPropagation()">
      <div class="user-menu-hero-content">
        <span class="user-menu-avatar" aria-hidden="true">{{ userInitials }}</span>
        <div class="user-menu-meta">
          <span class="user-menu-name">{{ userName }}</span>
          <span class="user-menu-username" *ngIf="username">{{ '@' + username }}</span>
        </div>
      </div>
      <span class="user-menu-role" *ngIf="userRole">
        <mat-icon>verified_user</mat-icon>
        {{ userRoleLabel }}
      </span>
    </div>

    <button mat-menu-item type="button" (click)="toggleLanguage()">
      <mat-icon>translate</mat-icon>
      <span>{{ 'HEADER.LANGUAGE' | translate }}</span>
    </button>
    <button mat-menu-item type="button" (click)="systemService.changeTheme()">
      <mat-icon>dark_mode</mat-icon>
      <span>{{ 'HEADER.TOGGLE_THEME' | translate }}</span>
    </button>
    <button mat-menu-item type="button" class="menu-item-danger" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>{{ 'HEADER.LOGOUT' | translate }}</span>
    </button>
  </mat-menu>
</header>
